import React from 'react';
import { useNavigate } from 'react-router-dom';

const GrantManagementPage = ({ user }) => {
  const navigate = useNavigate();

  const handleTabClick = (path) => {
    if (user) {
      navigate(path);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Grant Submission Portal</h1>
          <p className="text-lg text-gray-600">Manage your grant applications and submissions</p>
        </div>

        {/* Main Actions Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {/* Grant Submission Card */}
          <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
            <div className="p-8 text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-lg mb-6 mx-auto">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">Grant Applications</h3>
              <p className="text-gray-600 mb-6">Create new grant applications, complete questionnaires, and submit required documents</p>
              <button 
                onClick={() => handleTabClick('/grant-submission')}
                className="w-full bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition-colors duration-200 font-medium text-lg"
              >
                Manage Applications
              </button>
            </div>
          </div>

          {/* Grant Registry Card */}
          <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
            <div className="p-8 text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-lg mb-6 mx-auto">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">Grant Registry</h3>
              <p className="text-gray-600 mb-6">View and manage your grant portfolio, track funding sources and grant details</p>
              <button 
                onClick={() => handleTabClick('/grant-list')}
                className="w-full bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition-colors duration-200 font-medium text-lg"
              >
                View Registry
              </button>
            </div>
          </div>
        </div>

        {/* Info Section */}
        <div className="mt-12 bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Getting Started</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">📝 Grant Applications</h3>
              <p className="text-gray-600">Create and manage your grant applications, complete required questionnaires, and upload supporting documents.</p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">📊 Grant Registry</h3>
              <p className="text-gray-600">Keep track of your grant portfolio, view awarded grants, and manage funding source information.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrantManagementPage;
